import { useNavigate, useParams } from 'react-router-dom';
import { Button, Card, CardContent, FormHelperText, Grid, MenuItem, Select, Stack, TextField, Typography } from '@mui/material';
import { useFormik, Form, FormikProvider } from 'formik';
import * as Yup from 'yup';
import { NOSPACE_REGEX } from '../../../utils/constants';
import errorHandler from '../../../utils/errorHandler';
import EdiorJodit from '../../../components/editor/editorJodit';
import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { apiCms } from '../../../services/AllServices';


const editorContentValidation = (cmsData, context) => {
  if (cmsData === undefined || cmsData === null) {
    return context.createError({ message: "Answer is required" });
  }

  const plainText = cmsData
    .replace(/<[^>]*>/g, "") 
    .replace(/&nbsp;/gi, " ")
    .trim();

  if (!plainText) {
    return context.createError({ message: "Answer is required" });
  }

  if (/^\s|^(&nbsp;)+/i.test(cmsData.replace(/<[^>]*>/g, ""))) {
    return context.createError({ message: "Answer should not start with a space" });
  }

  if (plainText.length < 10) {
    return context.createError({ message: "Answer must be at least 10 characters long" });
  }

  return true;
};


const validationSchema = Yup.object().shape({
  question: Yup.string()
    .required("Question is required")
    .matches(NOSPACE_REGEX, "Please Enter a valid Question")
    .min(2, "Please enter at least 2 characters")
    .max(100, "Question must not be more than 100 characters."),
  answer: Yup.string().test(
    "custom-description-validation",
    "Answer is required",
    function (value) {
      return editorContentValidation(value, this);
    }),
});


export default function AddEditFaq() {
  const navigate = useNavigate();
  const [cmsData, setCmsData] = useState("");
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      apiCms
        .getByIdFaq({ id: id })
        .then((res) => {
          const data = res?.data?.data;
          formik.setValues({
            question: data.question,
            answer: data.answer,
            status: data.status,
          });
          // setCmsData(data.answer);
        })
        .catch((err) => {
          errorHandler(err);
        });
    }
  }, [id]);

  const formik = useFormik({
    initialValues: { question: '', answer: '', status: 'active' },
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {

      const apiCall = id ? apiCms.editFaq({
        id: id,
        question: values.question,
        answer: values.answer,
        status: values.status,
      })
        :
        apiCms.addFaq({
          question: values.question,
          answer: values.answer,
          status: values.status,
        });
      apiCall
        .then((res) => {
          toast.success(res?.data?.message);
          navigate("/faq");
          setSubmitting(false);
        })
        .catch((err) => {
          errorHandler(err);
          setSubmitting(false);
        });
    },
  });

  const { errors, touched, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <>
      <Card>
        <CardContent>
          <FormikProvider value={formik} style={{ padding: "34px 30px" }}>
            <Typography variant="h4" sx={{ mb: 2 }} align="start">
              {id ? 'Edit' : 'Add'} FAQ
            </Typography>
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={3}>
                <TextField
                  name="question"
                  label="Question"
                  {...getFieldProps("question")}
                  error={Boolean(touched.question && errors.question)}
                  helperText={touched.question && errors.question}
                />
                {/* <EdiorJodit
                  onChange={(html) => {
                    setCmsData(html);
                  }}
                  data={cmsData}
                  placeholder="Answer"
                /> */}
                <EdiorJodit
                  formik={formik}
                  fieldName="answer"
                  onChange={(val) => formik.setFieldValue("answer", val)}
                  data={formik?.values?.answer}
                />
                {formik.touched.answer && formik.errors.answer && (
                  <FormHelperText error>
                    {formik.errors.answer}
                  </FormHelperText>
                )}
                <Grid item xs={12}>
                  <Select
                    labelId="status-label"
                    id="status"
                    value={formik.values.status}
                    onChange={(e) =>
                      formik.setFieldValue("status", e.target.value)
                    }
                    fullWidth
                    error={Boolean(
                      formik.touched.status && formik.errors.status
                    )}
                    displayEmpty
                    defaultValue=""
                  >
                    <MenuItem value={"active"}>Active</MenuItem>
                    <MenuItem value={"inactive"}>Inactive</MenuItem>
                  </Select>
                  {formik.touched.status && formik.errors.status && (
                    <FormHelperText error>
                      {formik.errors.status}
                    </FormHelperText>
                  )}
                </Grid>
              </Stack>
              <Stack
                spacing={2}
                mt={3}
                direction="row"
                alignItems="center"
                justifyContent="flex-end"
              >
                <Button
                  size="large"
                  type="submit"
                  variant="contained"
                  disabled={isSubmitting}
                  sx={{ my: 2 }}
                >
                  {id ? 'Update' : 'Add'}
                </Button>
                <Button
                  size="large"
                  variant="contained"
                  onClick={() => {
                    if (!isSubmitting)
                      navigate("/faq");
                  }}
                  sx={{ my: 2, ml: 4 }}
                >
                  Cancel
                </Button>
              </Stack>
            </Form>
          </FormikProvider>
        </CardContent>
      </Card>
    </>
  );
}